import classNames from "classnames";

import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import { useTranslations } from "@jti/ui";

import styles from "./SubscriptionBenefits.module.scss";

const BenefitItem = ({ children }: { children: React.ReactNode }) => (
  <li className={styles.benefitItem}>
    <UiCheckIcon className={styles.checkIcon} />
    {children}
  </li>
);

export const SubscriptionBenefits = () => {
  const { __ } = useTranslations();

  const benefits = [];
  for (let i = 1; i <= 5; i++) {
    const benefit = __(`summarySubscription.benefit${i}`);
    if (benefit) {
      benefits.push(<BenefitItem key={i}>{benefit}</BenefitItem>);
    }
  }

  if (!benefits.length) return null;

  return (
    <div className={classNames(styles.section, styles.sectionBenefits)}>
      <ol className={styles.benefitsList}>{benefits}</ol>
    </div>
  );
};
